import { MimeType } from '../components/constants/MimeType';

// You need some way to pause execution until the image.onload event fires
// When you call image.src = url, the browser starts loading the image asynchronously.
// The code that follows executes immediately — before the image has finished loading.
const loadImage = (image: HTMLImageElement, src: string) =>
    new Promise<void>((resolve, reject) => {
        image.onload = () => resolve();
        image.onerror = reject;
        image.src = src;
    });

export const getChartBase64String = async (svgId: string, canvasHeight: number, canvasWidth: number, originalChartWidth: number, originalChartHeight: number, imageHeight: number, imageWidth: number): Promise<string> => {
    const svg = document.getElementById(svgId);
    if (!svg) {
        return '';
    }
    // Convert the SVG DOM node into a XML string
    const svgData = new XMLSerializer().serializeToString(svg);
    // Create a Blob from the XML string so it can be treated like a file/image
    const svgBlob = new Blob([svgData], { type: MimeType.SVG_BLOB });
    // Prepare a canvas and 2D rendering context to draw the image
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // Create a temporary image element to load the SVG Blob
    const image = new Image();
    const url = URL.createObjectURL(svgBlob);
    await loadImage(image, url);
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    // Draw and scale the SVG image - the 0, 0 are the starting x and y, we pass in the original SVG height and width
    // then pass in the canvas starting x and y followed by the canvas height so it can stretch the image to the new size proportionally.
    ctx?.drawImage(image, 0, 0, originalChartWidth, originalChartHeight, 0, 0, imageWidth, imageHeight);
    URL.revokeObjectURL(url);
    return canvas.toDataURL(MimeType.PNG);
};
